enum NotificationType {
    SUCCESS,
    WARN,
    ERR,
    INFO,
}
export default NotificationType;